module.exports = __webpack_public_path__ + "img/pageBanner-ConnectUs.6e5f31a5.jpg";